/* eslint-disable @nx/enforce-module-boundaries */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

// components
import * as feature from '@usimweb/ui/feature';

import { AuthGuard } from '@usimweb/core-auth';

import * as fromGuards from './core/guards';
import { ResultComponent } from './feature/result/container/result/result.component';
import { NewFoamingComponent } from './feature/new-foaming/container/newfoaming.component';
import { ViewerComponent } from './feature/viewer/container/viewer/viewer.component';
import { CompareComponent } from './feature/compare/container/compare/compare.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'app/projects',
    pathMatch: 'full',
  },
  {
    path: 'app/projects',
    canActivate: [fromGuards.ProjectsGuard],
    component: feature.ProjectsComponent,
  },
  {
    path: 'app/versions/:id',
    canActivate: [fromGuards.VersionsGuard],
    component: feature.VersionsComponent,
  },
  {
    path: 'app/newProject',
    component: feature.NewProjectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'app/newFoaming/:id',
    component: NewFoamingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'app/newFoaming/:id/:id2',
    component: NewFoamingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'app/result/:id/:id2',
    component: ResultComponent,
    canActivate: [AuthGuard, fromGuards.ResultGuard],
  },
  // {
  //   path: 'app/compare/:id/:id2',
  //   component: CompareComponent,
  //   canActivate: [AuthGuard, fromGuards.CompareGuard],
  // },
  {
    path: 'app/compare/:id/:id2/:id3',
    component: CompareComponent,
    canActivate: [AuthGuard, fromGuards.CompareGuard],
  },
  {
    path: 'app/invite_confirmation/:id',
    component: feature.InvConfirmationComponent,
    canActivate: [AuthGuard, fromGuards.InvitationGuard],
  },
  {
    path: 'app/contacts',
    component: feature.ContactsComponent,
    //canActivate: [AuthGuard],
  },
  {
    path: 'app/credits',
    component: feature.CreditsComponent,
    canActivate: [AuthGuard, fromGuards.CreditsGuard],
  },
  {
    path: 'app/viewer/:id/:id2',
    component: ViewerComponent,
    canActivate: [AuthGuard, fromGuards.ViewerGuard],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    ...fromGuards.guards,
  ],
})
export class AppRoutingModule {}
